import React            from 'react'
import {useHistory}     from "react-router"
import {useTranslation} from "react-i18next"

import {IonIcon, IonItemOption, useIonAlert} from "@ionic/react"
import {trashOutline, trashSharp} from "ionicons/icons"

import {TimeLimit}     from "@customTypes/TimeLimit"
import {useTimeLimits} from "../../../contexts/TimeLimitContext"


interface componentProps {
    item: TimeLimit
}

const ListItemOptionDelete: React.FC<componentProps> = ({item}) => {
    const history = useHistory()
    const { deleteItem } = useTimeLimits()
    const [presentAlert] = useIonAlert()
    const { t }          = useTranslation()

    const closeItemSliding = () => {
        document.querySelector('ion-item-sliding')?.closeOpened();
    }

    const alertDelete = async () => {
        if (
            (item.keyTimeLimits && item.keyTimeLimits?.length > 0)
            || (item.lockTimeLimits && item.lockTimeLimits?.length > 0)
        ) {
            return presentAlert({
                header:  t('time-limits.alerts.delete.header_not_possible'),
                message: t('time-limits.alerts.delete.message_not_possible'),
                buttons: [{
                    text:    t('common.cancel'),
                    role:    'cancel'
                }],
            })
        }

        return presentAlert({
            header:  t('time-limits.alerts.delete.header'),
            message: t('time-limits.alerts.delete.message'),
            buttons: [{
                text:    t('common.cancel'),
                role:    'cancel'
            }, {
                text:    t('common.delete'),
                role:    'confirm',
                handler: () => onDelete(),
            },],
        })

    }

    const onDelete = async () => {
        closeItemSliding()

        await deleteItem(item)

        history.push('/time-limits')
    }

    return (
        <IonItemOption color="danger" onClick={() => alertDelete()}>
            <IonIcon slot="top" ios={trashOutline} md={trashSharp} />
            {t('common.delete')}
        </IonItemOption>
    )
}

export default ListItemOptionDelete